import { CvPublishTypeEnum } from '@/../gen';

export default {
  title: 'タイトル',
  publish_type: {
    [CvPublishTypeEnum.Open]: '公開',
    [CvPublishTypeEnum.OpenUnlisted]: '限定公開',
    [CvPublishTypeEnum.OpenWithPw]: 'パスワード付き',
    [CvPublishTypeEnum.Secret]: '非公開',
  },
  publish_type_details: {
    [CvPublishTypeEnum.Open]: {
      sub_title: 'Web上で一般公開',
      description:
        'インターネット上の誰でも検索、アクセスができます。ログインは不要。',
    },
    [CvPublishTypeEnum.OpenUnlisted]: {
      sub_title: 'URLを知っている全員',
      description: 'URLを知っている全員がアクセスができます。ログインは不要。',
    },
    [CvPublishTypeEnum.OpenWithPw]: {
      sub_title: 'パスワードを入力して閲覧',
      description:
        '閲覧時にパスワード入力をしないと閲覧できません。ログインは不要。',
    },
    [CvPublishTypeEnum.Secret]: {
      sub_title: '自分のみ閲覧可',
      description:
        'インターネット上では閲覧できなくなります。自分のアカウントでログインが必要。',
    },
  },
  password: 'パスワード',
  password_confirmation: 'パスワード（確認用）',
  original_path: '公開用URL',
  publish_date: '公開日時',
};
